module.exports = __webpack_public_path__ + "static/egypt-91b42fc881d319a0f22579775a15546f.png";